import ErrorDisplay from '../../../components/ErrorDisplay';
import Loading from '../../../components/Loading';
import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { DaysOffForm } from './DaysOffForm';
import { EnrollmentForm } from './EnrollmentForm';
import { InfoTip } from '../../../components/ui/toogle-tip';
import { seasonSpanUpdate } from '../../../operations/admin/seasonSpanUpdate';
import { setDocumentTitle } from '../../../utils/documentTitle';
import { TimeRangeForm } from '../../../components/TimeRangeForm';
import { toaster } from '../../../components/ui/toaster';
import { useDatabase } from '../../../hooks/useDatabase';
import { useEffect } from 'react';
import { useSettings } from '../../../hooks/useSettings';

function SettingsPage() {
	useEffect(setDocumentTitle('Ustawienia')); // eslint-disable-line react-hooks/exhaustive-deps
	const database = useDatabase()
	const [settings, settingsLoading, settingsError] = useSettings();

	const handleSeasonSpanUpdate = async (values: { firstDay: string; lastDay: string }) => {
		try {
			await seasonSpanUpdate(database, values);
			toaster.create({
				title: 'Zapisano',
				type: 'success',
				duration: 3000,
			});
		} catch (error) {
			console.error('Failed to update season span', error);
			toaster.create({
				title: 'Nie udało się zapisać zmian',
				type: 'error',
				duration: 3000,
			});
		}
	}

	if (settingsLoading)
		return <Loading />
	if (settingsError)
		return <ErrorDisplay error={settingsError}/>

	return (
        <Box p={{ base: 4, lg: 6 }}>
            <VStack align="stretch" gap={6}>
                <Box borderWidth="1px" borderColor="gray.200" borderRadius="lg" p={{ base: 4, lg: 5 }} bg="white">
					<Flex alignItems="center" gap={2}>
						<Heading size="md">Początek i koniec sezonu (roku szkolnego)</Heading>
						<InfoTip
							content="Wpływa na daty wyświetlane w tytułach i nagłówkach oraz na wyliczenia dat zajęć przy ich startowaniu."
							positioning={{ placement: 'right' }}
							contentProps={{
								bg: 'gray.50',
								color: 'gray.800',
								borderWidth: '1px',
								borderColor: 'gray.100',
								borderRadius: 'md',
								fontSize: 'xs',
								boxShadow: 'sm',
							}}
						/>
					</Flex>
                    
					<TimeRangeForm
						onSubmit={(values: { firstDay: string; lastDay: string }) => handleSeasonSpanUpdate(values)}
						submitBtnText="Zapisz"
						defaultValues={settings?.seasonSpan}
						// onCancel={() => setCardMode('view')}
					/>
					
                    
					<Text fontSize="sm" color="gray.600" mt={4} fontStyle="italic">
                        Zmiana końca roku szkolnego nie usuwa ani nie dodaje lekcji wystartowanym zajęciom. Trzeba je wtedy dodać lub usunąć ręcznie.
                    </Text>
                </Box>

				<DaysOffForm daysOff={settings?.daysOff ?? []} />
				<EnrollmentForm
					value={settings?.enrollmentAvailable}
					bannerOptions={settings?.bannerOptions}
				/>
            </VStack>
        </Box>
    );
}

export default SettingsPage;